import { render, staticRenderFns } from "./shipping-policies.vue?vue&type=template&id=ff143932"
import script from "./shipping-policies.vue?vue&type=script&lang=js"
export * from "./shipping-policies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports